import React from 'react';

function Phone(props) {
    const className = props.className;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            className={className}
        >
            <linearGradient
                id="phone-icon-background"
                x1="286.984"
                x2="286.984"
                y1="626.266"
                y2="624.767"
                gradientTransform="matrix(60 0 0 -60 -17169 37581)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#67FF81" />
                <stop offset="1" stopColor="#01B41F" />
            </linearGradient>
            <path
                fill="url(#phone-icon-background)"
                d="M63.6 5c9 0 13.5 0 18.4 1.5 5.3 1.9 9.5 6.1 11.4 11.4 1.6 5 1.6 9.5 1.6 18.5v27.2c0 9 0 13.5-1.5 18.4-1.9 5.3-6.1 9.5-11.4 11.4C77.2 95 72.7 95 63.6 95H36.4c-9 0-13.5 0-18.4-1.5-5.3-2-9.5-6.1-11.4-11.5C5 77.2 5 72.7 5 63.6V36.4c0-9 0-13.5 1.5-18.4 2-5.3 6.2-9.5 11.5-11.4C22.9 5 27.4 5 36.4 5h27.2z"
            />
            <path
                fill="#FFF"
                d="M25.7 44.3c-3.3-6-4.6-10.9-4.6-14.2s.8-4.2 1.6-5c.8-.8 4.5-3 5.2-3.5.6-.4 3-1.3 4.5.9s4.3 6.5 6.3 9.4c3.1 4.1.6 5.9-.2 7-1.5 2-2.3 2.5-2.3 4.9 0 2.4 6.8 9.4 8.4 11.1 1.6 1.7 8.4 7.6 10.5 8 2.1.3 5-1.9 5.6-2.5 3.1-2.4 4.8-.6 6.2.2 1.4.8 7.8 4.8 9.8 6.1 1.9 1.3 1.7 3.4 1.7 3.4s-1.3 3.9-4.3 6.8c-.7.7-2 1.6-5.1 1.6-3.1 0-6.5-.6-14.5-5-6.5-3.6-12.7-9.2-16-12.5-3.3-3.2-9-9.8-12.8-16.7z"
            />
        </svg>
    );
}

export default Phone;
